import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import zh from './locales/zh.json';
import ja from './locales/ja.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import zhTW from './locales/zh-TW.json';
import ar from './locales/ar.json';
import pt from './locales/pt.json';
import id from './locales/id.json';
import ko from './locales/ko.json';
import vi from './locales/vi.json';
import ru from './locales/ru.json';

i18n
  // 检测用户语言
  .use(LanguageDetector)
  // 注入 react-i18next 实例
  .use(initReactI18next)
  // 初始化 i18next
  .init({
    resources: {
      en: { translation: en },
      zh: { translation: zh },
      'zh-CN': { translation: zh },
      tw: { translation: zhTW }, // 使用 'tw' 作为 URL 路径简写
      'zh-TW': { translation: zhTW }, // 同时也支持标准 locale code
      ja: { translation: ja },
      de: { translation: de },
      fr: { translation: fr },
      es: { translation: es },
      ar: { translation: ar },
      pt: { translation: pt },
      id: { translation: id },
      ko: { translation: ko },
      vi: { translation: vi },
      ru: { translation: ru },
    },
    fallbackLng: 'en', // 默认语言
    debug: import.meta.env.MODE === 'development',
    
    detection: {
      // 仅检测 URL 路径和浏览器语言，不使用缓存
      order: ['path', 'navigator'],
      // 禁用缓存，不写入任何 storage
      caches: [], 
    },

    interpolation: {
      escapeValue: false, // React 已经能够防止 XSS
    },
  });

export default i18n;

